var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M2.625 2.1875L11.375 11.8125",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M8.4716 8.61861C8.0423 9.00881 7.47559 9.2125 6.89611 9.18488C6.31664 9.15726 5.77187 8.90059 5.38163 8.47133C4.99139 8.04207 4.78765 7.47537 4.81522 6.89589C4.84279 6.31642 5.09941 5.77162 5.52864 5.38135",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M4.04657 3.75122C1.817 4.88027 0.875 7.00001 0.875 7.00001C0.875 7.00001 2.625 10.9371 7 10.9371C8.02506 10.9452 9.03732 10.7091 9.95299 10.2483",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M11.4083 9.24757C12.6006 8.17968 13.125 6.99995 13.125 6.99995C13.125 6.99995 11.375 3.06202 6.99995 3.06202C6.62104 3.0614 6.24272 3.09221 5.8689 3.15412",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M7.41162 4.85132C7.87656 4.9406 8.30002 5.17822 8.61848 5.52853C8.93694 5.87885 9.13323 6.32298 9.17791 6.7943",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eyeSlash.311222289275b0ecaa3f1a13722943fe.svg";
export { ForwardRef as ReactComponent };